import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import useRegions from '@/common/hooks/useRegions/useRegions'
import configurationServices from '@/configuration/services/services'
import inventoryServices from '@/inventory/services/services'

const useInventoryConfiguration = ({ storeId, setToastInfo }) => {
  const { t } = useTranslation()
  const {
    data,
    loading,
    setData,
    resetData,
    hasChanges,
    fetchData: getShipmentsConfiguration,
  } = useFetch(configurationServices.getShipmentsConfiguration, {
    doInitialRequest: true,
    params: { storeId },
  })
  const { fetchData: editShipmentsConfiguration, loading: editingShipmentsConfiguration } = useFetch(
    configurationServices.editShipmentsConfiguration,
    { doInitialRequest: false }
  )
  const { data: customsRequirements, loading: loadingCustomsRequirements } = useFetch(
    inventoryServices.getCustomsRequirements,
    { doInitialRequest: true, params: { storeId } }
  )
  const { regions, loading: loadingRegions } = useRegions()

  const needsNsPid = !!customsRequirements?.needs_ns_pid

  const onChange = (field, value) => {
    setData(prevData => ({
      ...prevData,
      [field]: value,
    }))
  }

  const onSaveChanges = async () => {
    try {
      await editShipmentsConfiguration({ storeId, payload: data })
      await getShipmentsConfiguration({ storeId })
      setToastInfo({ show: true, type: 'success', message: t('Configuración guardada correctamente') })
    } catch (error) {
      setToastInfo({ show: true, type: 'error', message: error.errorMessage })
    }
  }

  return {
    data,
    loading: loading || loadingRegions || loadingCustomsRequirements,
    setData,
    resetData,
    onChange,
    hasChanges,
    onSaveChanges,
    editingShipmentsConfiguration,
    regions,
    needsNsPid,
  }
}

export default useInventoryConfiguration
